import { PublicExtensionCapabilities } from '@epilot/customer-portal-client'

// Dev mock — mirrors the shape returned by getPublicPortalExtensionDetailsV3.
// `type_options`, `aggregation_method_options` and `data_range` are not yet
// in the upstream OpenAPI types but are read by the chart via an unknown cast.
//
// Aggregation grouping drives chart rendering:
//   - same aggregation_group → values stack within a single bar
//   - different aggregation_group → values render as parallel bars per slot
//
// Here HT + NT share "tariff" (stacked tariff split).
export const MOCK_PUBLIC_EXTENSIONS: PublicExtensionCapabilities = {
  consumptionDataRetrieval: [
    {
      extension: {
        id: '96e62f90-0c5f-4538-868b-d7d2ed9561d3',
        name: { en: '', de: 'Consumption Retrieval' }
      },
      hook: {
        id: 'consumption',
        name: { en: 'Consumption', de: 'Consumption' },
        intervals: ['PT15M', 'PT1H', 'P1D', 'P1M'],
        // Extra fields read by the consumption chart block (not in OpenAPI yet)
        ...({
          app: {
            name: 'Portal Consumption',
            app_id: '75b9f271-8ca1-4825-8e20-81bb2c185550'
          },
          type_options: [
            {
              id: 'ht',
              label: { en: 'High tariff', de: 'Hochtarif' },
              aggregation_group: 'tariff',
              statistical_method: 'sum',
              unit: 'kWh'
            },
            {
              id: 'nt',
              label: { en: 'Low tariff', de: 'Niedertarif' },
              aggregation_group: 'tariff',
              statistical_method: 'sum',
              unit: 'kWh'
            }
          ],
          aggregation_method_options: [
            { id: 'sum', label: { en: 'Total', de: 'Gesamt' } }
          ],
          data_range: {
            from: '2024-01-01T00:00:00Z',
            to: '2026-05-01T00:00:00Z'
          }
        } as Record<string, unknown>)
      }
    }
  ]
}

// Alternative type_option presets — swap into MOCK_PUBLIC_EXTENSIONS.hook
// (or into the block's content.consumptionDataRetrieval.typeOptions) to test
// the other rendering modes.

// Stacked bar: HT + NT share one aggregation_group → both stack in one bar.
export const STACKED_TYPE_OPTIONS = [
  {
    id: 'ht',
    label: { en: 'High tariff', de: 'Hochtarif' },
    aggregation_group: 'tariff',
    unit: 'kWh'
  },
  {
    id: 'nt',
    label: { en: 'Low tariff', de: 'Niedertarif' },
    aggregation_group: 'tariff',
    unit: 'kWh'
  }
]

// Non-aggregation-group: no type_options at all. Pair with consumption data
// that has no `type` field so the chart renders a single ungrouped series.
export const UNGROUPED_TYPE_OPTIONS: never[] = []

// Min/max area band + avg line (within a single aggregation_group). Pair with
// consumption data containing min/max/avg-typed points to render the line
// shape variant of the chart.
export const LINE_METRIC_TYPE_OPTIONS = [
  {
    id: 'temp-min',
    label: { en: 'Min temperature', de: 'Mintemperatur' },
    aggregation_group: 'temperature',
    statistical_method: 'min',
    unit: 'kWh'
  },
  {
    id: 'temp-max',
    label: { en: 'Max temperature', de: 'Maxtemperatur' },
    aggregation_group: 'temperature',
    statistical_method: 'max',
    unit: 'kWh'
  },
  {
    id: 'temp-avg',
    label: { en: 'Avg temperature', de: 'Durchschnittstemperatur' },
    aggregation_group: 'temperature',
    statistical_method: 'average',
    unit: 'kWh'
  }
]
